export default __webpack_public_path__ + "static/media/Vazir-Thin.7882bfe5.woff";